module.exports = KsysAppTemplateV2dot2dot4;